import { Box, type SxProps, type Theme, Typography } from '@mui/material';

export type CountPillProps = Readonly<{
  value: number | string;
  sx?: SxProps<Theme>;
}>;

/** A count in a small rounded outline. */
export const CountPill = ({ value, sx }: CountPillProps) => (
  <Box sx={[pillSx, ...(Array.isArray(sx) ? sx : [sx])] as SxProps<Theme>}>
    <Typography variant="text-xs-medium" sx={textSx}>
      {typeof value === 'number' ? value.toLocaleString() : value}
    </Typography>
  </Box>
);

const pillSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 24,
  minWidth: 24,
  paddingX: backrs.spacing['spacing-xs'],
  boxSizing: 'border-box',
  borderRadius: backrs.radius['radius-full'],
  border: `1px solid ${backrs.colors['Colors/Border/border-primary']}`,
  backgroundColor: backrs.colors['Colors/Background/bg-primary'],
  flexShrink: 0,
});

const textSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-secondary'],
});
